import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

const textSample =
  'Body Text, e.g. with around 155,000 employees worldwide, the Allianz Group serves 126 mn customers in more than 70 countries. On the insurance side, Allianz is the market leader in the German market and has a strong international presence.';

export default {
  title: 'Components/Text',
  component: 'a1-text',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Content Component - Default Text block component.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-text';

const Template = (args: Components.A1Text): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Text> = Template.bind({});
Default.args = {
  text: textSample,
};

export const Secondary: Story<Components.A1Text> = Template.bind({});
Secondary.args = {
  ...Default.args,
  type: 'secondary',
};

export const Small: Story<Components.A1Text> = Template.bind({});
Small.args = {
  ...Default.args,
  size: 's',
};

export const Large: Story<Components.A1Text> = Template.bind({});
Large.args = {
  ...Default.args,
  size: 'l',
};

export const PrimaryInverse: Story<Components.A1Text> = Template.bind({});
PrimaryInverse.args = {
  ...Default.args,
  inverse: true,
};
PrimaryInverse.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const SecondaryInverse: Story<Components.A1Text> = Template.bind({});
SecondaryInverse.args = {
  ...Secondary.args,
  inverse: true,
};
SecondaryInverse.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};
